import { render, staticRenderFns } from "./SeasonAssessment.vue?vue&type=template&id=54103e84&"
import script from "./SeasonAssessment.vue?vue&type=script&lang=js&"
export * from "./SeasonAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports